import { Component, OnInit, Input, Output, EventEmitter, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { AppUrls } from '../../../utility/appurls';
import { GenericLookupForm } from '../generic-lookup-form';
import { Observable } from 'rxjs';
import { UntypedFormGroup } from '@angular/forms';
import { DynamicFormsService } from '../../../dynamic-forms/services/dynamic-forms/dynamic-forms.service';
import { ReferenceDataService } from '../../../reference-data/reference-data.service';
import { FormsModule } from '@angular/forms';
import { DynamicFormLoadDirective } from '../../../dynamic-forms/directives/dynamic-form-structural.directive';
import { TextInputComponent } from '../../../dynamic-forms/dynamic-form-inputs/text-input/text-input.component';
import { SelectInputComponent } from '../../../dynamic-forms/dynamic-form-inputs/select-input/select-input.component';

@Component({
  selector: 'lib-external-user-lookup-form',
  templateUrl: './external-user-lookup-form.component.html',
  styleUrls: ['./external-user-lookup-form.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [FormsModule, DynamicFormLoadDirective , TextInputComponent, SelectInputComponent],
     
})
export class ExternalUserLookupFormComponent extends GenericLookupForm implements OnInit {
  private dynamicFormsService = inject(DynamicFormsService);
  private referenceDataService = inject(ReferenceDataService);

  @Output() enterKey: EventEmitter<any> = new EventEmitter();
  @Input() events: Observable<void>;
  @Input() queryObject: any;
  formLoaded = false;
  AppUrls = AppUrls;
  entityId: number;
  entityTypeCode: string;
  entityGroupRoleCode: string;
  selectedEntityGroupRole$: string;

  
 

  constructor() {
    super();
  }

  ngOnInit() {
    this.dynamicFormsService
      .getFormGroupForModel('systemExternalUserLookupForm')
      .subscribe(formInfo => {
        this.formInfo = formInfo;
        this.form = formInfo.formGroup;

        this.entityId = this.queryObject['entityId'];
        this.entityTypeCode = this.queryObject['entityCode'];
        this.form.controls['entityId'].setValue(this.queryObject['entityId']);
        this.form.controls['entityTypeCode'].setValue(this.queryObject['entityTypeCode']);
        this.form.controls['entityGroupRoleCode'].setValue(this.queryObject['entityGroupRoleCode']);

        this.updateEntityGroupRole();
        this.markFormGroupTouched(this.form);
        this.formLoaded = true;
      });
  }

  search() {
    this.enterKey.emit();
  }

  public isValid(): boolean {
    return this.form && this.form.valid;
  }

  public reset(): void {
    this.form.reset();
    this.form.get('entityGroupRoleName').patchValue(this.selectedEntityGroupRole$);
  }

  private markFormGroupTouched(formGroup: UntypedFormGroup) {
    (<any>Object).values(formGroup.controls).forEach((control: UntypedFormGroup) => {
      control.markAsTouched();

      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

  private updateEntityGroupRole() {
    const fixedEntityGroupRoleCode = this.queryObject['entityGroupRoleCode'];
    if (fixedEntityGroupRoleCode) {
      this.referenceDataService.getReferenceData('EntityGroupRole').subscribe(refData => {
        this.selectedEntityGroupRole$ = refData[0].options.find(
          g => g.code === fixedEntityGroupRoleCode,
        ).name;
        this.form.get('entityGroupRoleName').patchValue(this.selectedEntityGroupRole$);
      });
    }
  }
}
